import { Box, Divider, InputLabel, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import identityInfo from "../../../../../../media/images/icons/identityInfo-icon.svg";
import ArrowDownSVG from "../../../../../../media/images/icons/arrow-down";
import DangerFill from "../../../../../../media/images/icons/danger-fill";
import InfoCircle from "../../../../../../media/images/icons/info-circle";
import CustomInput from "../../../../../components/CustomInput";
import CustomSelectOption from "../../../../../components/CustomSelectOption";
import CheckCircle from "../../../../../../media/images/icons/check-circle";
import CustomButton from "../../../../../components/CustomButton";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/useRedux";
import { PreventInputAlpha } from "../../../../../../utils/functions";
import { useFormik } from "formik";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../../services/fetcher";
import {
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../../../redux/features/dialogSlice";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../../redux/features/snackbarSlice";
import { toJalaali } from "jalaali-js";
import { setBirthDate } from "../../../../../../redux/features/userSlice";
import * as yup from "yup";

export default function IdentityInfo() {
  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useAppDispatch();

  const theme = useTheme();

  const { fullName, nationalCode, birthDate, licenseNumber } = useAppSelector(
    (state) => state.user
  );
  const mymonths = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ];

  const toggleBox = () => {
    setIsOpen(!isOpen);
  };

  const formik = useFormik({
    initialValues: {
      licenseNumber: "",
      year: "",
      month: "",
      day: "",
    },

    validationSchema: yup.object().shape({
      licenseNumber: yup.string().required("این فیلد الزامی است!"),
      year: yup.string().required(" فیلد الزامی !"),
      month: yup.string().required(" فیلد الزامی !"),
      day: yup.string().required(" فیلد الزامی !"),
    }),
    validateOnChange: true,

    onSubmit: (values) => {
      const newValues = {
        licenseNumber: values.licenseNumber,
        BirthDateYear: Number(values.year) + 1320,
        BirthDateMonth: Number(values.month),
        BirthDateDay: Number(values.day),
      };

      postPersonalInfo(newValues);
    },
  });

  const { trigger: postPersonalInfo, isMutating: isPostAccoumodationMutating } =
    useSWRMutation(
      [
        `/Account/DriverSetBirthDate
`,
        localStorage.getItem("access_token"),
      ],

      fetcherPost,
      {
        onSuccess: () => {
          dispatch(
            setBirthDate({
              day: formik.values.day,
              month: formik.values.month,
              year: formik.values.year,
            })
          );

          dispatch(setOpenDialog(true));
          dispatch(setDialogStatus("success"));
          dispatch(setDialogTitle("ثبت اطلاعات با موفقیت انجام شد!"));
        },
      }
    );

  const handleSelectOption = (value: any, type: string) => {
    switch (type) {
      case "year":
        formik.setFieldValue("year", Number(value));
        break;

      case "month":
        formik.setFieldValue("month", Number(value));
        break;

      case "day":
        formik.setFieldValue("day", Number(value));

        break;

      default:
        break;
    }
  };

  useEffect(() => {
    formik.setFieldValue("year", birthDate?.year);
    formik.setFieldValue("month", birthDate?.month);
    formik.setFieldValue("day", birthDate?.day);
    formik.setFieldValue("licenseNumber", licenseNumber);
  }, [birthDate]);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.bgColor.white,
        display: "flex",
        flexDirection: "column",
        border: "1px solid",
        borderColor: theme.palette.bgColor.blueGrey100,
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          justifyContent: "space-between",
          padding: "8px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "start",
            gap: "4px",
          }}
        >
          <img width={32} src={identityInfo} alt="" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "16px",
              }}
            >
              اطلاعات هویتی
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              شماره گواهینامه، تاریخ تولد، تلفن‌همراه
            </Typography>
          </Box>
        </Box>

        <CustomButton
          justifyContent="space-between"
          onClick={() => toggleBox()}
          bgColor={isOpen ? "error.light" : theme.palette.secondary[50]}
          title={isOpen ? "بستن جزئیات" : "  مشاهده/ویرایش"}
          fSize="12px"
          fWeight="600"
          rippleColor={
            isOpen ? theme.palette.error.main : theme.palette.secondary.main
          }
          borderColor={isOpen ? "error.main" : "secondary.main"}
          py="10px"
          px="6px"
          gap="4px"
          borderRadius="8px"
          textColor={isOpen ? "error.main" : "secondary.main"}
          icon2={
            <Box
              sx={{
                transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s",
              }}
            >
              <ArrowDownSVG
                size={14}
                color={
                  isOpen
                    ? theme.palette.error.main
                    : theme.palette.secondary.main
                }
              />
            </Box>
          }
        />
      </Box>
      <Box
        sx={{
          overflow: "hidden",
          maxHeight: isOpen ? "1000px" : 0,
          transition: isOpen ? "max-height 0.5s ease" : "max-height 0.2s ease",
          paddingX: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Divider variant="fullWidth" />

        <Box
          sx={{
            backgroundColor: theme.palette.primary[50],
            borderRadius: "8px",
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <DangerFill color={theme.palette.primary.main} />
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              توجه:
            </Typography>
          </Box>
          <Typography
            sx={{
              color: "primary.main",
              fontSize: "12px",
              textAlign: "justify",
            }}
          >
            شماره گواهینامه و تاریخ تولد در تکمیل فرآیند احراز هویت اجباری
            میباشد.
          </Typography>
        </Box>
        <Box
          sx={{
            flex: "1",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  color: theme.palette.primary[600],
                  fontWeight: "700",
                  fontSize: "14px",
                }}
              >
                کدملی راننده:{" "}
              </Typography>
              <Box
                sx={{
                  backgroundColor: theme.palette.bgColor.blueGrey100,
                  textAlign: "center",
                  borderRadius: "8px",
                  padding: "8px 0px",
                }}
              >
                {nationalCode || "----------"}
              </Box>
            </Box>
            <Box
              sx={{
                marginTop: "4px",
                display: "flex",
                gap: "4px",
              }}
            >
              <InfoCircle color={theme.palette.secondary.dark} size={20} />
              <Typography
                sx={{
                  fontSize: "12px",
                  color: theme.palette.secondary[700],
                }}
              >
                کدملی قابل تغییر نمی‌باشد.
              </Typography>
            </Box>
          </Box>
          <Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  color: theme.palette.primary[600],
                  fontWeight: "700",
                  fontSize: "14px",
                }}
              >
                نام و نام خانوادگی راننده:
              </Typography>
              <Box
                sx={{
                  backgroundColor: theme.palette.bgColor.blueGrey100,
                  textAlign: "center",
                  borderRadius: "8px",
                  padding: "8px 0px",
                }}
              >
                {fullName || "--------"}
              </Box>
            </Box>
            <Box
              sx={{
                marginTop: "4px",
                display: "flex",
                gap: "4px",
              }}
            >
              <InfoCircle color={theme.palette.secondary.dark} size={20} />
              <Typography
                sx={{
                  fontSize: "12px",
                  color: theme.palette.secondary[700],
                }}
              >
                نام و نام‌خانوادگی قابل تغییر نمی‌باشد.
              </Typography>
            </Box>
          </Box>

          {/**licence number */}
          <Box>
            <Typography
              sx={{
                color: theme.palette.primary[600],
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              شماره گواهینامه:
            </Typography>

            <CustomInput
              type="numeric"
              name="licenseNumber"
              handelChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (e.target.value.length > 10) return;
                PreventInputAlpha(e, formik.handleChange);
              }}
              handelOnBlur={formik.handleBlur}
              value={formik.values.licenseNumber}
              errorMessage={
                formik.touched.licenseNumber && formik.errors.licenseNumber
              }
              error={
                formik.touched.licenseNumber &&
                Boolean(formik.errors.licenseNumber)
              }
              placHolder="شماره گواهینامه راننده را وارد کنید..."
            />
          </Box>
          {/**date of brith */}
          <div
            className="selectDate"
            style={{
              display: "flex",
              // alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <InputLabel
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
                htmlFor="outlined-adornment-amount"
              >
                {"روز تولد:"}
              </InputLabel>

              <CustomSelectOption
                type="day"
                setValue={handleSelectOption}
                height="40px"
                value={formik.values.day}
                errorMessage={formik.touched.day && formik.errors.day}
                error={formik.touched.day && Boolean(formik.errors.day)}
                options={[
                  // {
                  //   value: 1,
                  //   label: "انتخاب روز",
                  //   disabled: true,
                  // },
                  ...new Array(31).fill(1).map((item, index) => ({
                    label: String(1 + index),
                    value: index + 1,
                  })),
                ]}
              />
            </Box>

            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <InputLabel
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
                htmlFor="outlined-adornment-amount"
              >
                {"ماه تولد:"}
              </InputLabel>
              <CustomSelectOption
                type="month"
                setValue={handleSelectOption}
                height="40px"
                value={formik.values.month}
                errorMessage={formik.touched.month && formik.errors.month}
                error={formik.touched.month && Boolean(formik.errors.month)}
                options={[
                  // {
                  //   value: 1,
                  //   label: "انتخاب ماه",
                  //   disabled: true,
                  // },
                  ...mymonths.map((item, index) => ({
                    label: String(item),
                    value: index + 1,
                  })),
                ]}
              />
            </Box>
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <InputLabel
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
                htmlFor="outlined-adornment-amount"
              >
                {"سال تولد:"}
              </InputLabel>

              <CustomSelectOption
                type="year"
                setValue={handleSelectOption}
                height="40px"
                value={formik.values.year} // Ensure this matches one of the available options
                errorMessage={formik.touched.year && formik.errors.year}
                error={formik.touched.year && Boolean(formik.errors.year)}
                options={[
                  // {
                  //   value: 1, // This is a valid option now
                  //   label: "انتخاب سال",
                  //   disabled: true, // This makes the "Select Year" option not selectable
                  // },
                  ...new Array(81).fill(1).map((item, index) => ({
                    label: String(1320 + index + 1),
                    value: index + 1,
                  })),
                ]}
              />
            </Box>
          </div>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <CheckCircle color={theme.palette.success.main} />
            <Typography
              sx={{
                fontSize: "14px",
                color: "success.main",
              }}
            >
              برای اعمال شدن تغییرات حتما ذخیره اطلاعات را بزنید
            </Typography>
          </Box>

          <Box
            sx={{
              gap: "8px",
              display: "flex",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomButton
              flex={1}
              justifyContent="center"
              onClick={() => toggleBox()}
              bgColor={theme.palette.primary[50]}
              title={"انصراف"}
              fSize="16px"
              fWeight="700"
              borderColor={theme.palette.primary.main}
              py="10px"
              px="6px"
              gap="4px"
              borderRadius="6px"
              textColor={theme.palette.primary.main}
            />
            <CustomButton
              flex={1}
              justifyContent="center"
              onClick={() => formik.handleSubmit()}
              bgColor={"primary.main"}
              title={"ذخیره اطلاعات"}
              fSize="16px"
              fWeight="700"
              py="10px"
              px="6px"
              gap="4px"
              borderRadius="6px"
              textColor={"#fff"}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
